module.exports = __webpack_public_path__ + "static/img/plano.09059024.jpg";